// @flow
import { useForm } from 'hooks/useForm'
import FormsPageFormListItems from 'pages/FormsPage/FormsPageFormListItems'
import * as React from 'react'
import type { QueueItem } from 'types/queue-item'
import Button from 'ui/atoms/Button'
import Flex from 'ui/atoms/Flex'
import List from 'ui/atoms/List'
import Space from 'ui/atoms/Space'
import Text from 'ui/atoms/Text'

import Pagination from '../../ui/atoms/Pagination'
import { PublicURLModal } from './Components'

type Props = {
  hasUrlModal: boolean,
  handleItemClick?: (item: any) => void,
  isEmpty: boolean,
  isFetchingForms: boolean,
  isPacket: boolean,
  items: Array<any>,
  itemsCount: number,
  itemsAsLinks: boolean,
  loading: boolean,
  navigateToStartForms: () => void,
  onPublicFormClick: (string, string, string) => void,
  onPublicFormDismiss: () => void,
  onSelectResource: (string) => void,
  publicFormName: ?string,
  publicUrl: ?string,
  selectedResources: Array<QueueItem>,
  tabletMode: boolean,
  setLoading: (boolean) => void,
}

function FormsPageFormList({
  hasUrlModal,
  handleItemClick,
  isEmpty,
  isFetchingForms,
  isPacket,
  items,
  itemsCount,
  itemsAsLinks,
  loading,
  navigateToStartForms,
  onPublicFormClick,
  onPublicFormDismiss,
  onSelectResource,
  publicFormName,
  publicUrl,
  selectedResources,
  tabletMode,
  setLoading,
}: Props): React.Node {
  const { total } = useForm()

  return (
    <Space className="pb-11">
      {tabletMode && (
        <Text $light $small>
          {isPacket
            ? 'Select a packet below to fill'
            : 'Select forms below to fill in sequence'}
        </Text>
      )}
      <List
        $scrollable={tabletMode}
        headerText="Form name"
        loading={isFetchingForms}
      >
        <FormsPageFormListItems
          handleItemClick={handleItemClick}
          isEmpty={isEmpty}
          isPacket={isPacket}
          items={items}
          itemsAsLinks={itemsAsLinks}
          loading={loading}
          onPublicFormClick={onPublicFormClick}
          onSelectResource={onSelectResource}
          selectedResources={selectedResources}
          setLoading={setLoading}
          tabletMode={tabletMode}
        />
        <Pagination total={isPacket ? itemsCount : total} />
      </List>
      {tabletMode && (
        <Flex justify="end">
          <Button
            $primary
            dataCy="start-to-fill-button"
            disabled={!selectedResources.length}
            onClick={navigateToStartForms}
          >
            Start to Fill
          </Button>
        </Flex>
      )}
      {hasUrlModal ? (
        <PublicURLModal
          {...{
            title: publicFormName,
            onClose: onPublicFormDismiss,
            publicUrl,
          }}
        />
      ) : null}
    </Space>
  )
}

export default FormsPageFormList
